import React, { Fragment } from 'react'
import QuestionsPagePublic from './QuestionsPagePublic'

const HomePage = () => {
    return (
        <Fragment>
            <div className="col-8 offset-2">
                <QuestionsPagePublic />
            </div>
        </Fragment>
    )
}

export default HomePage
